<template>
	<div class="dashboard">
		<div v-bind:class="venue_selected.value === 'all' ? 'd-none' : ''" class="bg-white container-fluid p-0 pt-5">

			<!--PDF Export-->
			<div v-if="venue_data" style="position: fixed; top: -1000px; left: -1000px; width: 680px; height: 680px">
				<stats-graph
					class="position-fixed"
					:graph_data="venue_data.bar_graph_data"
					:sideways="true"
					:disable_duration="true"
					@update_graph_image="updatedBarGraphImage"
				></stats-graph>
				<radial-graph
					class="position-fixed"
					:graph_data="venue_data.scores"
					subtitle_1="last_audit"
					:subtitle_2="'Average score for \'' + venue_selected.name + '\''"
					:disable_duration="true"
					@update_graph_image="updatedRadialGraphImage"
				></radial-graph>
			</div>


			<div class="container">
				<!--Header-->
				<div class="row m-auto justify-content-center p-2">
					<div class="col-12 col-md-4 text-light text-center text-md-left mb-4 mb-md-0">
						<div v-if="venue_selected.value === 'all'" class="m-0">
							<h5>All Venues Audit Scores</h5>
							<span>{{venues.length}} venues</span>
						</div>
						<div v-else class="m-0 d-inline-flex">
							<h5 class="my-auto">{{venue_selected.name}}</h5>
							<a
								v-if="venue_edit_url" :href="venue_edit_url.replace('?', venue_selected.value)"
								class="ml-3 my-auto btn btn-primary btn-sm rounded-circle"
							><i class="fa fa-pencil"></i></a>
						</div>
					</div>
					<div class="col-8 col-md-4 my-auto text-light text-center">
						<custom_select
							empty_message="No data found"
							name="selected_year"
							no_selection_name="-- Year --"
							extra_class="text-pink text-center"
							:pre_selected="year_selected"
							:in_line="true"
							:options="year_options"
							@selected="selectYear"
						></custom_select>
					</div>
					<div class="col-4 text-right">
						<div class="d-inline-flex my-auto">
							<a href="javascript:void(0)" v-on:click="main_page = 0">
								<i class="radio-selector fa fa-2x fa-tasks" v-bind:class="main_page === 0 ? 'active' : ''"></i>
							</a>
							<strong class="mx-1">|</strong>
							<a href="javascript:void(0)" v-on:click="main_page = 1">
								<i class="radio-selector fa fa-2x fa-calendar" v-bind:class="main_page === 1 ? 'active' : ''"></i>
							</a>
						</div>
					</div>
				</div>


				<!--Card Content-->
				<!--page 1-->
				<div v-if="main_page === 0" class="">
					<div v-if="loading_venue_data" class="mt-2 w-100 p-5">
						<div class="loaders--standard mx-auto"></div>
					</div>

					<div v-else-if="venue_data !== null">
						<!--Carousel NOT VISIBLE IN MOBILE-->
						<div class="mt-3 d-none d-lg-block">
							<dashboard_carousel
								:venue="venue_selected"
								:venue_data="venue_data"
								:pre_selected_page="carousel_page"
								@select_page="carousel_page = $event"
							></dashboard_carousel>
						</div>

						<!--List NOT VISIBLE IN DESKTOP-->
						<div class="m-auto mt-2 d-lg-none">
							<dashboard_list
								:venue="venue_selected"
								:venue_data="venue_data"
							></dashboard_list>
						</div>
					</div>

					<div v-else class="mt-2 w-100 text-center">
						<h4 class="">No data found</h4>
					</div>
				</div>

				<!--page 2 -->
				<div v-else-if="main_page === 1" class="">
					<div v-if="loading_venue_data" class="mt-2 w-100 p-5">
						<div class="loaders--standard mx-auto"></div>
					</div>

					<div v-else-if="venue_data !== null">
						<single-venues-audits
							:data="venue_data.schedule_page"
							:schedule_url="schedule_create_link"
							:schedule_edit_url="schedule_edit_url"
							:downloading_pdf="downloading"
							@export_pdf="exportPDF"
						></single-venues-audits>
					</div>

					<div v-else class="mt-2 w-100 text-center">
						<h4 class="">No data found</h4>
					</div>
				</div>
			</div>
		</div>


		<!--Rest of the container-->
		<div v-if="venue_selected.value === 'all'" class="container mt-5" v-bind:class="venue_selected.value === 'all' ? 'pt-5' : ''">
			<!--all pages-->

			<!--leaderboard stuff-->
			<div class="row m-auto justify-content-center p-2 text-primary">
				<div class="col-12 col-lg-8 ml-lg-0 container">
					<div class="row">
						<div class="col-12 col-sm-8 text-center text-sm-left">
							<h3 class="text-dark font-weight-bold ">Leaderboard</h3>
						</div>
						<div class="col-12 col-sm-4 d-inline-flex justify-content-center">
							<custom_select
								empty_message=""
								name="selected_group"
								no_selection_name="-- Select --"
								extra_class="text-pink text-center"
								:prepend_selection="{label: 'Audit Score', value: 'all'}"
								:pre_selected="content_group"
								:in_line="true"
								:options="leaderboard_group_options"
								@selected="selectGroup"
							></custom_select>
							<custom_select
								empty_message=""
								name="selected_filter"
								no_selection_name="-- Select --"
								extra_class="text-pink text-center"
								:pre_selected="content_filter"
								:in_line="true"
								:options="leaderboard_filter_options"
								@selected="selectFilter"
							></custom_select>
						</div>
					</div>
					<div v-if="!loading_content_data && content_data !== null" class="row mt-1">
						<leader-board
							v-if="content_data.leader_board.length"
							:leader_board="content_data.leader_board"
						></leader-board>
						<div v-else class="col-12">
							<h4>
								No data to show
							</h4>
						</div>
					</div>
				</div>
				<div v-bind:class="loading_content_data ? 'd-none d-md-block' : ''" class="col-12 col-lg-3 mr-lg-0 text-left container">
					<div class="row">
						<div class="col-12 p-0"><h3 class="font-weight-bold text-dark">Latest Audit Scores</h3></div>
					</div>
					<div v-if="!loading_content_data && content_data !== null">
						<div class="row" v-for="audit in content_data.latest_audits">
							<a :href="view_audit_url.replace('?', audit.id)" class="link-unstyled w-100">
								<audit-card
									:venue_name="audit.venue.name"
									:total_score="audit.score"
									:improved="audit.improved"
									:user="audit.user"
									:created_at="audit.formatted_date"
								></audit-card>
							</a>
						</div>
						<div class="row mt-2">
							<div class="col-12 p-0 text-center text-md-left">
								<h3 class="font-weight-bold ">Schedule</h3>
							</div>
						</div>
						<div v-if="content_data !== null" class="row">
							<div class="col-12">
								<div v-if="content_data.schedule_table.length" class="container p-0">
									<div class="row">
										<div class="col-12 p-0" v-for="schedule in content_data.schedule_table">
											<schedule-card-component
												:date="schedule.formatted_date"
												:user="schedule.user"
												:venue_name="schedule.venue.name"
												:schedule_url="schedule_edit_url.replace('?', schedule.id)"
											></schedule-card-component>
										</div>
									</div>
								</div>
								<h5 v-else>No audits overdue</h5>
							</div>
						</div>
						<div class="row mt-2">
							<div class="col-12 p-0 text-center text-md-left">
								<h3 class="font-weight-bold">Overdue</h3>
							</div>
						</div>
						<div v-if="content_data !== null" class="row">
							<div class="col-12">
								<div v-if="content_data.overdue.length" class="container p-0">
									<div class="row">
										<div class="col-12 p-0" v-for="overdue in content_data.overdue">
											<overdue-card
												:venue_name="overdue.venue.name"
												:auditors="overdue.auditors"
												:last_audited="overdue.venue.formatted_last_audited"
												:schedule_url="schedule_edit_url.replace('?', overdue.id)"
											></overdue-card>
										</div>
									</div>
								</div>
								<h5 v-else>No audits overdue</h5>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row" v-if="loading_content_data">
				<div class="col-12 mt-2 p-5">
					<div class="loaders--standard mx-auto"></div>
				</div>
			</div>
		</div>


		<div v-else class="container mt-5">
			<!--all pages-->

			<div v-if="latest_audits_data !== null && latest_audits_data.length" class="row mb-2">
				<div class="col-12"><h3 class="font-weight-bold ">Latest audits</h3></div>
				<div class="col-12 col-md-6 col-lg-4" v-for="audit in latest_audits_data">
					<a :href="view_audit_url.replace('?', audit.id)" class="link-unstyled w-100">
						<audit-card
							:venue_name="audit.venue.name"
							:total_score="audit.score"
							:improved="audit.improved"
							:user="audit.user"
							:created_at="audit.formatted_date"
							:larger="true"
						></audit-card>
					</a>
				</div>
				<div v-if="loading_latest_audits_data || latest_audits_pagination.page < latest_audits_pagination.last_page" class="col-12 text-center">
					<button class="btn btn-primary px-5" v-on:click="nextAuditsPageLoad()" v-bind:disabled="loading_latest_audits_data">Load more</button>
				</div>
			</div>

			<div v-else-if="!loading_latest_audits_data.length" class="mt-2 w-100 text-center">
				<h4 class="">No data found</h4>
			</div>

			<div v-if="loading_latest_audits_data" class="mt-2 w-100 p-5">
				<div class="loaders--standard mx-auto"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import CustomSelectComponent from '../general_components/CustomSelectComponent.vue';
	import DashboardCarouselComponent from './graphs/DashboardCarouselComponent.vue';
	import DashboardListComponent from './graphs/DashboardListComponent.vue';
	import AuditCardComponent from './content/AuditCardComponent.vue';
	import LeaderboardTableComponent from './content/LeaderBoardTableComponent.vue';
	import SchedulesTableComponent from './content/SchedulesTableComponent.vue';
	import OverdueCardComponent from './content/OverdueCardComponent.vue';
	import ScheduleCardComponent from './content/ScheduleCardComponent.vue';
	import StatsGraphComponent from './graphs/StatsGraphComponent.vue';
	import RadialGraphComponent from './graphs/RadialGraphComponent.vue';

	import AllVenuesAuditsComponent from './schedule_page/AllVenuesAuditsComponent.vue';
	import SingleVenueAuditsComponent from './schedule_page/SingleVenueAuditsComponent.vue';


	import URLEditing from '../../helpers/URLEditing';
	import {venue_selection_bus} from '../../vue_components';

	export default {
		components:{
			ScheduleCardComponent,
			'custom_select': CustomSelectComponent,
			'dashboard_carousel': DashboardCarouselComponent,
			'dashboard_list': DashboardListComponent,
			'audit-card': AuditCardComponent,
			'leader-board': LeaderboardTableComponent,
			'schedules-table': SchedulesTableComponent,
			'all-venues-audits': AllVenuesAuditsComponent,
			'single-venues-audits': SingleVenueAuditsComponent,
			'stats-graph': StatsGraphComponent,
			'radial-graph': RadialGraphComponent,
			'overdue-card': OverdueCardComponent,
			'schedule-card-component': ScheduleCardComponent,
		},

		props:[
			'venues',
			'venue_pre_selected',
			'year_pre_selected',
			'load_data_url',
			'page',
			'schedule_create_url',
			'schedule_edit_url',
			'pdf_export_url',
			'view_audit_url',
			'venue_edit_url',
			'leaderboard_filter_options',
			'leaderboard_group_options'
		],

		data(){
			return {
				venue_selected: null,
				year_selected: null,
				years: [],

				content_filter: 'year',
				content_group: 'all',

				carousel_page: 0,
				main_page: 0,

				venue_data: null,
				content_data: null,
				schedule_data: null,
				latest_audits_data: [],

				latest_audits_pagination: {
					page: 1,
					last_page: 1,
				},

				loading_venue_data: false,
				loading_content_data: false,
				loading_schedule_data: false,
				loading_latest_audits_data: false,

				reload_venue_data: false,
				reload_content_data: false,
				reload_schedule_data: false,
				reload_latest_audits_data: false,

				bar_graph_data: null,
				radial_graph_data: null,

				downloading: false,
			}
		},

		beforeMount(){
			this.main_page = this.page ? parseInt(this.page) : 0;
			this.venue_selected = this.venue_pre_selected;
			this.years = this.venue_selected.years;

			if (this.year_pre_selected){
				this.year_selected = parseInt(this.year_pre_selected)
			}
			else {
				this.year_selected = this.years.length  ? this.years[this.years.length -1] : null;
			}

			if (this.venue_selected.value === 'all'){
				this.main_page = 0;
				this.editUrl();
			}
		},

		mounted() {
			let _this = this;

			//When a venue is selected
			venue_selection_bus.$on('select', function (venue){
				if (venue.value === 'all'){
					_this.main_page = 0;
				}

				_this.venue_selected = venue;
				_this.years = venue.years;
				_this.year_selected = venue.years.length ? venue.years[venue.years.length -1] : null;
				_this.editUrl();
				_this.loadData();
			});

			_this.loadData();
		},

		methods: {
			editUrl(){
				URLEditing.appendToUrl({
					year: this.year_selected,
					venue: this.venue_selected.value,
					page: this.main_page,
				});
			},


			loadVenueData(){
				let
					_this = this,
					url = URLEditing.getURLWithParams(_this.load_data_url, {
						year: _this.year_selected,
						venue: _this.venue_selected.value,
						type: 'venue_data'
					});

				if (_this.loading_venue_data){
					_this.reload_venue_data = true;
					return;
				}

				_this.loading_venue_data = true;

				axios.get(url)
					.then(function (response){
						_this.loading_venue_data = false;

						//Need to reload?
						if (_this.reload_venue_data){
							_this.reload_venue_data = false;
							_this.loadVenueData();
							return;
						}

						_this.venue_data = response.data;
					})
			},

			loadContentData(){
				let
					_this = this,
					url = URLEditing.getURLWithParams(_this.load_data_url, {
						type: 'content_data',
						filter: _this.content_filter,
						group_filter: _this.content_group
					});

				if (_this.loading_content_data){
					_this.reload_content_data = true;
					return;
				}

				_this.loading_content_data = true;

				axios.get(url)
					.then(function (response){
						_this.loading_content_data = false;

						//Need to reload?
						if (_this.reload_content_data){
							_this.reload_content_data = false;
							_this.loadContentData();
							return;
						}

						_this.content_data = response.data;
					})
			},

			loadLastAuditsData(){
				let
					_this = this,
					url = URLEditing.getURLWithParams(_this.load_data_url, {
						type: 'latest_audits',
						page: _this.latest_audits_pagination.page,
						venue: _this.venue_selected.value
					});

				if (_this.loading_latest_audits_data){
					_this.reload_latest_audits_data = true;
					return;
				}

				if (_this.venue_selected.value === 'all'){
					//No need for all venues
					_this.reload_latest_audits_data = false;
					_this.loading_latest_audits_data = false;
					return;
				}

				_this.loading_latest_audits_data = true;

				axios.get(url)
					.then(function (response){
						_this.loading_latest_audits_data = false;

						//Need to reload?
						if (_this.reload_latest_audits_data){
							_this.reload_latest_audits_data = false;
							_this.loadLastAuditsData();
							return;
						}

						_this.latest_audits_data = _this.latest_audits_data.concat(response.data.data);
						_this.latest_audits_pagination.last_page = response.data.last_page;
					})
			},



			nextAuditsPageLoad(){
				this.latest_audits_pagination.page ++;
				this.loadLastAuditsData();
				this.$nextTick(function (){
					$('html,body').animate({ scrollTop: 9999 }, 'slow');
				})
			},



			loadData(){
				this.latest_audits_pagination.page = 1;
				this.latest_audits_pagination.last_page = 1;
				this.latest_audits_data = [];

				this.bar_graph_data = null;
				this.radial_graph_data = null;

				this.venue_data = null;

				if(this.venue_selected.value === 'all') this.loadContentData();

				this.loadVenueData();
				this.loadLastAuditsData();
			},

			selectYear(e) {
				this.year_selected = e.value;
				if (this.main_page === 0){
					this.carousel_page = 0;
				}
				this.editUrl();
				this.loadVenueData();
			},

			selectFilter(e) {
				this.content_filter = e.value;
				this.loadContentData();
			},

			selectGroup(e) {
				this.content_group = e.value;
				this.loadContentData();
			},

			updatedBarGraphImage (data){
				this.bar_graph_data = data;
			},

			updatedRadialGraphImage (data){
				this.radial_graph_data = data;
			},

			exportPDF() {
				let _this = this;


				if (_this.downloading || _this.bar_graph_data == null || _this.radial_graph_data == null){
					return;
				}

				_this.downloading = true;

				axios({
					url: _this.pdf_export_url,
					method: 'post',
					data: {
						venue: _this.venue_selected,
						venue_data: _this.venue_data,
						bar_graph_data: _this.bar_graph_data,
						radial_graph_data: _this.radial_graph_data,
						selected_year: _this.year_selected
					},
					responseType: 'blob'
				})
					.then(function (response){
						let
							link = document.createElement('a');

						link.href = window.URL.createObjectURL(new Blob([response.data]));
						link.setAttribute('download', _this.venue_selected.name + ' Venue Report.pdf');
						document.body.appendChild(link);
						link.click();

						_this.downloading = false;
					});
			}
		},

		watch: {
			main_page() {
				this.editUrl();
			}
		},

		computed: {
			year_options() {
				let years_data = [];

				for (let i=0; i<this.years.length; i++){
					years_data.push({
						label: this.years[i],
						value: this.years[i]
					});
				}

				return years_data;
			},

			schedule_create_link(){
				return URLEditing.getURLWithParams(this.schedule_create_url, {
					venue: this.venue_selected.value
				})
			},
		}
	}
</script>
